/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ListProjectSequencesParams = {
include_archived?: boolean;
search?: string | null;
cursor?: string | null;
/**
 * @minimum 1
 * @maximum 100
 */
per_page?: number;
};
